import emailjs from "emailjs-com";
import React from 'react';
export default function Form() {
	function sendEmail(e) {
        e.preventDefault();
     	emailjs.sendForm('service_2a8gd21', 'template_nk4h2p7', e.target, 'user_r7wqNBbr4LepmDMfYOdKk')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
        e.target.reset()
    }
	return(
	    <>
    	<div className="row">
            <div className="col-lg-10 offset-lg-1">
            	<form onSubmit={sendEmail}>
	                <div className="row">
	                    <div className="col-md-5">
	                        <div className="contact-form-left">
	                            <div className="form-group">
	                                <label for="name">Name</label>
	                                <input type="text" name="FullName" className="form-control" id="name" placeholder="Type your name here" required/>
	                            </div>
	                            <div className="form-group">
	                                <label for="email">Email</label>
	                                <input type="email" name="Email" className="form-control" id="email" placeholder="Type your email here" required/>
	                            </div>
	                            <div className="form-group">
	                                <label for="Phone">Phone</label>
	                                <input type="tel" name="Phone"className="form-control" id="telephone" placeholder="Type your phone here" required/>
	                            </div>
	                        </div>
	                    </div>
	                    <div className="col-md-7">
	                        <div className="contact-form-right">
	                            <div className="form-group">
	                                <label for="Message">Message</label>
	                                <textarea name="Message" cols="40" rows="10" className="form-control" id="Message" placeholder="Type your message here"></textarea>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	                <div className="row">
	                    <div className="col-md-6">
	                        <div className="form-group mb-0 form-check">
	                            <span className="wpcf7-form-control-wrap acceptance-921">
	                                <span className="wpcf7-form-control wpcf7-acceptance">
	                                    <span className="wpcf7-list-item">
	                                        <label>
	                                            <input type="checkbox" name="acceptance-921" value="1" aria-invalid="false" required/>
	                                            <span className="wpcf7-list-item-label">By ticking this box, I consent to Trufab Ltd. holding my information as defined in our <a href="/privacy-policy/">privacy policy.</a></span>
	                                        </label>
	                                    </span>
	                                </span>
	                            </span>
	                        </div>
	                    </div>
	                    <div className="col-md-6">
	                        <div className="submit-btn d-md-flex align-items-center justify-content-end">
	                            <input type="submit" value="submit" className="btn btn-primary" aria-invalid="false" />
	                            
	                        </div>
	                    </div>
	                </div>
	            </form>
                <div className="row">
                    <div className="col-md-12">
                        <div className="query-heading">
                            <div className="heading"><h2>Connect with us</h2></div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <ul className="social-links">
                            <li>
                                <a href="https://www.facebook.com/" target="_blank" rel="noopener"><i className="fab fa-facebook-square" aria-hidden="true"></i></a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/" target="_blank" rel="noopener"><i className="fab fa-linkedin" aria-hidden="true"></i></a>
                            </li>
                            <li>
                                <a href="https://twitter.com/" target="_blank" rel="noopener"><i className="fab fa-twitter-square" aria-hidden="true"></i></a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-9 d-md-flex align-items-md-end justify-content-md-end">
                        <ul className="query-list d-flex">
                            <li>
                                <div className="query-box">
                                    <i className="fas fa-map-marker-alt"></i>
                                    <p><a href="mailto:info@backsure.com">info@backsure.com</a></p>
                                    <p><a href="tel:01132983489">0113 298 3489</a></p>
                                </div>
                            </li>
                            <li>
                                <div className="query-box">
                                    <i className="fas fa-mobile-alt"></i>
                                    Unit 17, Something Park Business Village, Somewhere, Here, AB1 2CD
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
	    </>
	)
}